import { lazy } from "react";

export const LazyBrandReviewsListV2 = lazy(() =>
  import(
    /* webpackChunkName: "retailer-brand-reviews-list-v2" */ "@faire/retailer-visitor-shared/views/brand/BrandReview/V2/Components/BrandReviewsList"
  ).then((m) => ({ default: m.BrandReviewsList }))
);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
LazyBrandReviewsListV2.displayName = "LazyBrandReviewsListV2";
